import React, { useEffect } from 'react';
import propTypes from 'prop-types';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
} from '../../../../../components/ui/Dialog';
import { Button } from '../../../../../components/ui/Button';
import { useDispatch, useSelector } from 'react-redux';
import { ACTION_TYPES, SharedListWithBar } from '../../../../../components/SharedListWithBar';
import {
  chooseTranslation,
  clearTranslations,
  getTranslations,
  startEditDetail,
} from '@/store/actions/classification';

const prepareData = (translation) => {
  if (!translation) return [];
  const { title } = translation;
  return [{ name: 'Název', value: title }];
};

const renderListOfTranslations = (translations, dispatch) => {
  return (translations || []).map((translation, i) => {
    const properties = prepareData(translation);
    const lang = translation?.language;
    return (
      <SharedListWithBar
        key={i}
        title={lang?.title}
        data={properties}
        actionType={ACTION_TYPES.EDIT}
        action={() => dispatch(chooseTranslation(lang?.code))}
      />
    );
  });
};

const ClassificationDetailModal = ({ visible, onClose }) => {
  const { detail, translations } = useSelector((state) => (state as any).classification);
  const dispatch = useDispatch();

  useEffect(() => {
    if (visible) dispatch(getTranslations());
  }, [visible]);

  useEffect(() => {
    return () => {
      dispatch(clearTranslations());
    };
  }, []);

  if (!detail) return null;

  const getData = () => {
    return [
      {
        name: 'Definuje komponentu',
        value: detail.is_def_component ? 'Ano' : 'Ne',
      },
      {
        name: 'Definuje skladbu',
        value: detail.is_def_composition ? 'Ano' : 'Ne',
      },
      { name: 'Aktivní', value: detail.is_active ? 'Ano' : 'Ne' },
    ];
  };

  return (
    <Dialog open={visible} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Editace detailu</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <SharedListWithBar
            title={detail.title}
            data={getData()}
            action={() => dispatch(startEditDetail())}
          />
          {renderListOfTranslations(translations, dispatch)}
        </DialogBody>
        <DialogFooter>
          <Button
            key={2}
            onClick={() => onClose()}
            data-testid="classification-detail-modal-close-btn"
          >
            Zavřít
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

ClassificationDetailModal.propTypes = {
  visible: propTypes.bool,
  onClose: propTypes.func,
  title: propTypes.string,
};

export default ClassificationDetailModal;
